"use client";

import { api } from "@/trpc/react";

export function VersionFooter() {
  const { data: { version, environment } = {} } =
    api.systemRouter.getApplicationMetadata.useQuery();

  return (
    <div className="fixed bottom-0 flex w-full items-center justify-start gap-2 text-xs text-gray-500">
      <span>{environment}</span>
      <span>{version}</span>
    </div>
  );
}
